<div
  [class]="
    'flex items-center bg-(--visitstatuscard-background) gap-(--visitstatuscard-gap) px-(--visitstatuscard-padding-x) py-(--visitstatuscard-padding-y) rounded-(--visitstatuscard-border-radius) ' +
    (config().shadow ? 'shadow-(--visitstatuscard-shadow) ' : '') +
    (config().showBorder
      ? 'border-(length:--visitstatuscard-border-width,var(--border-width-xs)) border-(--visitstatuscard-border-color)'
      : '')
  "
>
  <app-dynamic
    componentName="TimeBadge"
    [props]="{ config: timeBadgeConfig() }"
  />

  <div class="flex flex-col flex-1 gap-1 min-w-0">
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: headerTextConfig() }"
    />
    @if (config().subhead) {
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: subheadTextConfig() }"
      />
    }
  </div>
</div>
